import { TextField } from "@material-ui/core";
import { EventNote, TrendingFlat } from "@material-ui/icons";
import styled from "styled-components";

export default function RuleFive({value, onChange, type}) {

    async function handleChange() {
        var value1 = Number(document.getElementById(`01at15-${type}`).value)
        var value2 = Number(document.getElementById(`16at31-${type}`).value)

        if (value1 > 31) {
            value1 = 31
        } else if (value1 < 0) {
            value1 = 0
        }

        if (value2 > 31) {
            value2 = 31
        } else if (value2 < 0) {
            value2 = 0
        }

        onChange(`${value1}|${value2}`)
    }

    return (
        <RuleContainer>
            <RuleDescription>
                <EventNote style={{ fontSize: '16px', marginRight: '6px', color: '#667eea' }} />
                Janela Composta de Vencimento
            </RuleDescription>
            <Dates>
                <DateField>
                    <DateLabel>Entre o dia 01 e 15</DateLabel>
                    <StyledTextField>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id={`01at15-${type}`}
                            label="Dia do mês"
                            type="number"
                            placeholder="Ex: 5"
                            value={value.split('|')[0] || 0}
                            autoComplete="off"
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </StyledTextField>
                </DateField>
                <ArrowSeparator>
                    <TrendingFlat style={{ fontSize: '24px', color: '#667eea' }} />
                </ArrowSeparator>
                <DateField>
                    <DateLabel>Entre o dia 16 e 31</DateLabel>
                    <StyledTextField>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            id={`16at31-${type}`}
                            label="Dia do mês"
                            type="number"
                            placeholder="Ex: 20"
                            value={value.split('|')[1] || 0}
                            autoComplete="off"
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </StyledTextField>
                </DateField>
            </Dates>
        </RuleContainer>
    )
}

const RuleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const RuleDescription = styled.p`
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
    display: flex;
    align-items: center;
    font-family: 'Mulish', sans-serif;
`;

const Dates = styled.div`
    display: flex;
    gap: 16px;
    align-items: flex-end;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

const DateField = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const DateLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: #5a6c7d;
    font-family: 'Mulish', sans-serif;
`;

const ArrowSeparator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 8px;

    @media (max-width: 768px) {
        transform: rotate(90deg);
        padding: 8px 0;
    }
`;

const StyledTextField = styled.div`
    .MuiOutlinedInput-root {
        border-radius: 10px;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
        }

        &.Mui-focused {
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }
    }

    .MuiOutlinedInput-input {
        font-family: 'Mulish', sans-serif;
        font-size: 14px;
    }

    .MuiInputLabel-outlined {
        font-family: 'Mulish', sans-serif;
    }
`;